module.exports = __webpack_public_path__ + "static/d09-d5cc637d2e6a5f6f99b64b40f0bfcb30.png";